import { useState, useEffect } from 'react'

import gSession from '../script/session';
import gUtilities from '../script/utilities';
import TableWidget from './TableWidget';

const TaskPage = (props) => {
    const [task_list, setTaskList] = useState([]);

    async function update() {
        let request = {
            service: "db.query",
            collection: "dcs_task",
            many: true,
            query: {}
        };

        let response = await gSession.exchange(request);

        if (!isMounted()) {
            return;
        }

        if (response.isError) {
            gUtilities.showError("Task List Update", response.message);
            return;
        }

        for (let record of response.list) {
            record.fingerprint = gUtilities.fingerprint(record.task_id);
            record.request = gUtilities.fingerprint(record.request_id);
            record.date = record.timestamp.substring(5, 16);

            if (record.hasOwnProperty("key") && record.details.hasOwnProperty(record.key)) {
                record.key = "[" + record.key + "]" + gUtilities.fingerprint(record.details[record.key]);
            } else {
                record.key = "N/A";
            }
        }

        // latest datetime at top of table
        let sorted = response.list.sort((l, r) => {
            if (l.timestamp < r.timestamp) {
                return 1;
            } else if (l.timestamp > r.timestamp) {
                return -1;
            }

            return 0;
        });

        setTaskList(sorted);
    }

    const columns = [
        "name",
        "state",
        "request",
        "message",
        "key",
        "date",
        "fingerprint"
    ];

    const titles = [
        "Name",
        "State",
        "Request",
        "Message",
        "Key",
        "Date",
        "Fingerprint"
    ];

    function scheduleUpdate() {
        let id = setTimeout(() => {
            try {
                update();
            } catch (ex) {
                console.log("ERROR: [EXCEPTION] tasks update - ", ex);
            }
        }, 1000);

        return id;
    }

    // detect existance of this page's root <div>
    function isMounted() {
        return gUtilities.isMounted("w_TaskPageRootDiv");
    }

    // https://medium.com/@taylorhughes/simple-secure-direct-to-s3-uploads-from-modern-browsers-f42695e596ba
    //
    // Bucket permissions:
    //
    /*     
        const k_cors = [
            {
                "AllowedHeaders": [
                    "*"
                ],
                "AllowedMethods": [
                    "PUT",
                    "HEAD",
                    "GET"
                ],
                "AllowedOrigins": [
                    "*"
                ],
                "ExposeHeaders": []
            }
        ];
     */

    function uploadFile(file, presignedUploadUrl) {
        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            xhr.upload.addEventListener("progress", (e) => {
                if (e.lengthComputable) {
                    const pct = e.loaded / e.total;
                    console.log("PROGRESS: ", pct * 100, "%");
                }
            });
            xhr.upload.addEventListener("error", (e) => {
                reject(new Error("Upload failed: " + e.toString()));
            });
            xhr.upload.addEventListener("abort", (e) => {
                reject(new Error("Upload aborted: " + e.toString()));
            });
            xhr.addEventListener("load", (e) => {
                if (xhr.status === 200) {
                    resolve();
                } else {
                    reject(new Error("Upload failed " + xhr.status));
                }
            });
            xhr.open("PUT", presignedUploadUrl, true);
            try {
                xhr.send(file);
            } catch (e) {
                reject(new Error("Upload failed: " + e.toString()));
            }
        });
    }

    async function onPrescriptionFileSelect(evt) {
        let file = evt.target.files[0];
        let filename = file.name;

        let key = `task/upload/prescription/${filename}`;

        let url = await getPresignedUrl(key);
        if (!url) {
            return;
        }

        try {
            await uploadFile(file, url);
        } catch (ex) {
            gUtilities.showError("Submit Prescription", ex.toString());
            return;
        }

        await sendPrescriptionSubmission(key);
    }

    async function sendPrescriptionSubmission(key) {
        let request = {
            command: "task.prescription_submission",
            key: key
        };

        let response = await gSession.exchange(request);

        if (response.isError) {
            gUtilities.showError("Submit Subscription", response.message);
        }
    }

    async function getPresignedUrl(key) {
        let request = {
            command: "agent.s3_upload_url",
            key: key
        };

        let response = await gSession.exchange(request);

        if (response.isError) {
            gUtilities.showError("Get Upload URL", response.message);
            return false;
        }

        return response.url;
    }

    useEffect(() => {
        let timer_id = scheduleUpdate();

        // cleanup function: stop updates.
        return () => {
            clearTimeout(timer_id);
        };
    }, [task_list]);

    return (
        <div id="w_TaskPageRootDiv">
            <div>
                <label htmlFor="w_FileUploadInput" className="button"
                    style={{
                        background: "#0450d5",
                        color: "white",
                        "line-height": 1.2,
                        padding: "15px",
                        borderRadius: "4px",
                        cursor: "pointer"
                    }}>
                    Submit Prescription RTPLAN File
                </label>
                <input type="file" id="w_FileUploadInput" style={{ "opacity": 0 }} onChange={onPrescriptionFileSelect}></input>
            </div>
            <br></br>
            <div>
                <TableWidget name="Tasks" data={task_list} columns={columns} titles={titles} />
            </div>
        </div >
    );
}

export default TaskPage;